(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["balzy-advertorial-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'balzy_adv_deadline_v1';
    var timers = document.querySelectorAll('.balzy-adv__timer');
    if (timers.length) {
      var source = document.querySelector('[data-balzy-countdown]');
      var minutes = source ? parseInt(source.getAttribute('data-balzy-countdown'), 10) : 15;
      if (!minutes || minutes < 1) {
        minutes = 15;
      }

      var deadline = parseInt(window.localStorage.getItem(KEY), 10);
      var now = Date.now();
      if (!deadline || isNaN(deadline) || deadline < now) {
        deadline = now + minutes * 60000;
        try {
          window.localStorage.setItem(KEY, String(deadline));
        } catch (e) {}
      }

      var pad = function (n) {
        return n < 10 ? '0' + n : '' + n;
      };

      var render = function () {
        var diff = deadline - Date.now();
        if (diff <= 0) {
          deadline = Date.now() + minutes * 60000;
          try {
            window.localStorage.setItem(KEY, String(deadline));
          } catch (e) {}
          diff = deadline - Date.now();
        }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var text = (h > 0 ? pad(h) + ':' : '') + pad(m) + ':' + pad(s);
        timers.forEach(function (el) {
          el.textContent = text;
        });
      };

      render();
      window.setInterval(render, 1000);
    }

    var bar = document.querySelector('.balzy-adv__sticky');
    var hero = document.querySelector('.balzy-adv__hero');
    var offer = document.querySelector('.balzy-adv__offer');
    if (bar && hero) {
      var onScroll = function () {
        var show = hero.getBoundingClientRect().bottom < 0;
        if (show && offer && offer.getBoundingClientRect().top < window.innerHeight) {
          show = false;
        }
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    }

    var urgency = document.querySelector('.balzy-adv__urgency');
    if (urgency) {
      var setUrgencyOffset = function () {
        var top = 0;
        var stack = document.elementsFromPoint(Math.floor(window.innerWidth / 2), 2);
        for (var i = 0; i < stack.length; i++) {
          var el = stack[i];
          if (el === urgency || (el.closest && el.closest('.balzy-adv'))) {
            continue;
          }
          var cs = window.getComputedStyle(el);
          if (cs.position === 'fixed' || cs.position === 'sticky') {
            var r = el.getBoundingClientRect();
            if (r.top <= 2 && r.height > 0 && r.height < window.innerHeight * 0.5 && r.bottom > top) {
              top = r.bottom;
            }
          }
        }
        urgency.style.top = Math.round(top) + 'px';
      };
      setUrgencyOffset();
      window.addEventListener('scroll', setUrgencyOffset, { passive: true });
      window.addEventListener('resize', setUrgencyOffset, { passive: true });
    }

    var offerOptions = document.querySelectorAll('.balzy-adv__offer-option');
    var offerCta = document.querySelector('[data-balzy-offer-cta]');
    if (offerOptions.length && offerCta) {
      offerOptions.forEach(function (opt) {
        opt.addEventListener('click', function () {
          offerOptions.forEach(function (o) {
            o.classList.remove('is-active');
            o.setAttribute('aria-pressed', 'false');
          });
          opt.classList.add('is-active');
          opt.setAttribute('aria-pressed', 'true');
          var url = opt.getAttribute('data-balzy-url');
          if (url) {
            offerCta.setAttribute('href', url);
          }
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
